import { Component } from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {AuthService} from "../auth.service";
import Swal from 'sweetalert2';
import {Router, RouterLink} from "@angular/router";
import {Subscription} from "rxjs";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    TranslateModule
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  public forgotPasswordForm: FormGroup;
  subscriptions: Subscription[] = [];
  passwordTemporary:any;

  constructor(
      private authService: AuthService,
      private fb: FormBuilder,
      private router: Router,
  ){
    this.forgotPasswordForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  sendEmail(){
    if(this.forgotPasswordForm.valid){
      const email = {email:this.forgotPasswordForm.value["email"]}
      const sub = this.authService.resetPassword(email).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.passwordTemporary = res.data.temporaryPassword;
            Swal.fire({
              title : "Controlla la tua email",
              text : `Ti è stata inviata una password temporanea. Usala per accedere e, successivamente, crea una nuova password.`,
              confirmButtonColor : '#0d9a71',
              icon: "success",
              footer: `
        <div class="d-flex footer-sweetalert align-items-center overflow-hidden">
          <div class="col d-flex align-items-baseline justify-content-center">
            <img src="./../../../../assets/svg/alfa-force-logo.svg" alt="alfa force logo">
          </div>
          <div class="col bar-dx"></p>
        </div>
      `
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(['/auth']);
              }
            });
          }
        },
        error: (err: any) => {
          if (err.error.message) {
          }
        },
        complete: () => {
        }
      })
    } else {
      this.forgotPasswordForm.markAllAsTouched();
    }
  }

}
